import { defineStore } from 'pinia';
import { createStorage } from '@/utils/Storage';
import { store } from '@/store';
import { ACCESS_TOKEN, CURRENT_USER, CURRENT_PROJECT, IS_LOCKSCREEN, CSRF_TOKEN } from '@/store/mutation-types';
import { ResultEnum } from '@/enums/httpEnum';

const Storage = createStorage({ storage: localStorage });
import { getUserInfo, login } from '@/api/generic/user';
import { storage } from '@/utils/Storage';
import { useAsyncRouteStore } from '@/store/modules/asyncRoute';

export interface IUserState {
  token: string;
  username: string;
  firstName: string;
  lastName: string;
  nickname: string;
  phoneNumber: string;
  faxNumber: string;
  jobTitle: string;
  welcome: string;
  avatar: string;
  userId: any;
  defaultProjectId: any;
  currentProject: any;
  projects: any[];
  permissions: any[];
  info: any;
  isAdmin: boolean;
  isEquipTeam: boolean;
  isClinicalLead: boolean;
  isDeployment: boolean;
  isNoBudgetary: boolean;
  isSuperAdmin: boolean;
  emailOptIn: boolean;
}

export const useUserStore = defineStore({
  id: 'app-user',
  state: (): IUserState => ({
    // token: Storage.get(ACCESS_TOKEN, ''),
    token: sessionStorage.getItem(ACCESS_TOKEN) || '',
    username: '',
    firstName: '',
    lastName: '',
    nickname: '',
    phoneNumber: '',
    faxNumber: '',
    jobTitle: '',
    welcome: 'Welcom to HEPS :)',
    avatar: '',
    userId: null,
    defaultProjectId: null,
    currentProject: null,
    projects: [],
    permissions: [],
    // info: Storage.get(CURRENT_USER, {}),
    info: JSON.parse(sessionStorage.getItem(CURRENT_USER) || '{}'),
    isAdmin: false,
    isEquipTeam: false,
    isClinicalLead: false,
    isDeployment: false,
    isNoBudgetary: false,
    isSuperAdmin: JSON.parse(sessionStorage.getItem(CURRENT_USER) || '{}')?.is_super_admin || false,
    emailOptIn: true,
  }),
  getters: {
    getToken(): string {
      return this.token;
    },
    getAvatar(): string {
      return this.avatar;
    },
    getUsername(): string {
      return this.username;
    },
    getFirstName(): string {
      return this.firstName;
    },
    getLastName(): string {
      return this.lastName;
    },
    getFullName(): string {
      return this.lastName + ', ' + this.firstName;
    },
    getNickname(): string {
      return this.nickname;
    },
    getPhoneNumber(): string {
      return this.phoneNumber;
    },
    getFaxNumber(): string {
      return this.faxNumber;
    },
    getJobTitle(): string {
      return this.jobTitle;
    },
    getUserId(): any {
      return this.userId;
    },
    getDefaultProjectId(): any {
      return this.defaultProjectId;
    },
    getCurrentProject(): any {
      return this.currentProject;
    },
    getProjects(): [any][] {
      return this.projects;
    },
    getPermissions(): [any][] {
      return this.permissions;
    },
    getUserInfo(): object {
      return this.info;
    },
    isMobileDeployment(): boolean {
      return sessionStorage.getItem('IS_MOBILE') === 'true';
    },
  },
  actions: {
    setToken(token: string) {
      this.token = token;
    },
    setAvatar(avatar: string) {
      this.avatar = avatar;
    },
    setUserame(username: string) {
      this.username = username;
    },
    setFirstName(firstName: string) {
      this.firstName = firstName;
    },
    setLastName(lastName: string) {
      this.lastName = lastName;
    },
    setNickame(nickname: string) {
      this.nickname = nickname;
    },
    setPhoneNumber(phoneNumber: string) {
      this.phoneNumber = phoneNumber;
    },
    setFaxNumber(faxNumber: string) {
      this.faxNumber = faxNumber;
    },
    setJobTitle(jobTitle: string) {
      this.jobTitle = jobTitle;
    },
    setUserId(userId) {
      return (this.userId = userId);
    },
    setDefaultProjectId(defaultProjectId) {
      this.defaultProjectId = defaultProjectId;
    },
    setCurrentProject(currentProject) {
      this.currentProject = currentProject;
    },
    setProjects(projects) {
      this.projects = projects;
    },
    setPermissions(permissions) {
      this.permissions = permissions;
    },
    setUserInfo(info) {
      this.info = info;
    },
    setIsAdmin(isAdmin: boolean) {
      this.isAdmin = isAdmin;
    },
    setIsEquipTeam(isEquipTeam: boolean) {
      this.isEquipTeam = isEquipTeam;
    },
    setIsClinicalLead(isClinicalLead: boolean) {
      this.isClinicalLead = isClinicalLead;
    },
    setIsDeployment(isDeployment: boolean) {
      this.isDeployment = isDeployment;
    },
    setIsNoBudgetary(isNoBudgetary: boolean) {
      this.isNoBudgetary = isNoBudgetary;
    },
    setIsSuperAdmin(isSuperAdmin: boolean) {
      this.isSuperAdmin = isSuperAdmin;
    },
    setEmailOptIn(emailOptIn: boolean) {
      this.emailOptIn = emailOptIn;
    },
    // 登录
    async login(userInfo) {
      try {
        const response = await login(userInfo);
        const { result, code } = response;
        if (code === ResultEnum.SUCCESS) {
          // const ex = 7 * 24 * 60 * 60 * 1000; // token expiry in one week
          // storage.set(ACCESS_TOKEN, result.token, ex);
          // storage.set(CURRENT_USER, result, ex);
          // localStorage.setItem(CSRF_TOKEN, result.csrfToken); // Store CSRF token
          // storage.set(IS_LOCKSCREEN, false);
          sessionStorage.setItem(ACCESS_TOKEN, result.token);
          sessionStorage.setItem(CURRENT_USER, JSON.stringify(result));
          sessionStorage.setItem(CSRF_TOKEN, result.csrfToken); // Store CSRF token
          this.setToken(result.token);
          this.setUserInfo(result);
          this.setIsSuperAdmin(!!result.is_super_admin);
        }
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },

    // 获取用户信息
    GetInfo() {
      return new Promise((resolve, reject) => {
        const currentProject = sessionStorage.getItem(CURRENT_PROJECT);
        const params = {};
        if (!!currentProject) {
          Object.assign(params, {
            id: JSON.parse(currentProject).id,
          });
        }
        getUserInfo(params)
          .then((res) => {
            const result = res;
            if (!!result.is_navidata_staff || (result.permissions && result.permissions.length)) {
              const permissionsList = result.permissions;
              if(!!result.is_navidata_staff) permissionsList.push({value:'is_navidata_staff'});
              this.setPermissions(permissionsList);
            } else {
              reject(new Error('getUserInfo: permissionsList must be a non-null array !'));
            }
            !!result.defaultProjectId && this.setDefaultProjectId(result.defaultProjectId);
            !!result.currentProject && this.setCurrentProject(result.currentProject);
            !!result.projects && this.setProjects(result.projects);
            !!result && this.setUserInfo(result);
            !!result.avatar && this.setAvatar(result.avatar);
            !!result.username && this.setUserame(result.username);
            !!result.firstName && this.setFirstName(result.firstName);
            !!result.lastName && this.setLastName(result.lastName);
            !!result.nickname && this.setNickame(result.nickname);
            !!result.phoneNumber && this.setPhoneNumber(result.phoneNumber);
            !!result.faxNumber && this.setFaxNumber(result.faxNumber);
            !!result.jobTitle && this.setJobTitle(result.jobTitle);
            !!result.userId && this.setUserId(result.userId);
            this.setIsAdmin(!!result.currentProject?.role_json?.some((role: any) => role.id === 1));
            this.setIsEquipTeam(!!result.currentProject?.role_json?.some((role: any) => role.id === 7));
            this.setIsClinicalLead(!!result.currentProject?.role_json?.some((role: any) => role.id === 13));
            const isDeploymentUser = !!result.currentProject?.role_json?.some((role: any) => role.id === 14);
            this.setIsDeployment(isDeploymentUser);
            this.setIsNoBudgetary(!!result.currentProject?.role_json?.some((role: any) => role.budgetary == 'false'));
            // Set isSuperAdmin from user info API response or stored user info
            const storedUser = JSON.parse(sessionStorage.getItem(CURRENT_USER) || '{}');
            const isSuperAdmin = result.is_super_admin ?? storedUser.is_super_admin;
            this.setIsSuperAdmin(!!isSuperAdmin);
            this.setEmailOptIn(result.emailOptIn ?? true);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 登出
    async logout() {
      this.setPermissions([]);
      this.setUserInfo('');
      this.setIsDeployment(false);
      // storage.remove(ACCESS_TOKEN);
      // storage.remove(CURRENT_USER);
      sessionStorage.removeItem(ACCESS_TOKEN);
      sessionStorage.removeItem(CURRENT_USER);
      sessionStorage.removeItem(CSRF_TOKEN);
      sessionStorage.removeItem('IS_MOBILE');
      // Reset async route store to ensure fresh state on next login
      const asyncRouteStore = useAsyncRouteStore();
      asyncRouteStore.setDynamicAddedRoute(false);
      return Promise.resolve('');
    },
  },
});

// Need to be used outside the setup
export function useUserStoreWidthOut() {
  return useUserStore(store);
}
